import React from 'react';
import Nav, { NavProps } from 'react-bootstrap/Nav';

type Props = {
  defaultActiveKey?: string;
};

const Tabs: React.FC<Props & NavProps> = ({ defaultActiveKey = '/', children, ...rest }) => (
  <Nav defaultActiveKey={defaultActiveKey} {...rest}>
    {children}
  </Nav>
);

export default Tabs;
